﻿export class v1_3_request_booking_search_criteria_date {
   public year: number | null = null;
   public month: number | null = null;
   public day: number | null = null;
   public hour: number | null = null;
   public minute: number | null = null;
}